import React from "react";

const User = () => {
  return (
    <svg
      width="81"
      height="81"
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_940_57)">
        <path
          d="M40.5 45.5625C53.0771 45.5625 63.2812 35.3584 63.2812 22.7812C63.2812 10.2041 53.0771 0 40.5 0C27.9229 0 17.7188 10.2041 17.7188 22.7812C17.7188 35.3584 27.9229 45.5625 40.5 45.5625ZM60.75 50.625H52.033C48.5209 52.2387 44.6133 53.1562 40.5 53.1562C36.3867 53.1562 32.4949 52.2387 28.967 50.625H20.25C9.06504 50.625 0 59.69 0 70.875V73.4062C0 77.5986 3.40137 81 7.59375 81H73.4062C77.5986 81 81 77.5986 81 73.4062V70.875C81 59.69 71.935 50.625 60.75 50.625Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_940_57">
          <rect width="81" height="81" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default User;
